import { render, staticRenderFns } from "./TriggerCampaigns.vue?vue&type=template&id=1134f558"
import script from "./TriggerCampaigns.vue?vue&type=script&lang=js"
export * from "./TriggerCampaigns.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports